import { map, catchError, tap } from 'rxjs/operators';
import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { SaidaAutenticacao } from '@app/models/Autenticacao/SaidaAutenticacao.model';
import { Observable, throwError } from 'rxjs';
import { UtilService } from './util.service';
import { EntradaAutenticacao } from '@models/Autenticacao/EntradaAutenticacao.model';

@Injectable({ providedIn: 'root' })
export class ContaService {
  private _informacoesAutenticacao: SaidaAutenticacao;
  public _eventoLogin: EventEmitter<SaidaAutenticacao>;

  constructor(private router: Router,
    private httpClient: HttpClient,
    private utilService: UtilService,
    private location: Location) {
    this._eventoLogin = new EventEmitter<SaidaAutenticacao>();
  }

  funcaoAutenticarUsuarioViaAuthcode(authcode): Observable<SaidaAutenticacao> {
    const url = `${this.utilService.funcaoObterURLAPI()}/conta/AutenticarViaAuthcode`;
    var usuario = 'keycloak';

    return this.httpClient.post<SaidaAutenticacao>(url, <EntradaAutenticacao>{ login: usuario, senha: authcode })
      .pipe(
        tap(retorno => {
          if (retorno.tipoRetorno === 2) {
            this._informacoesAutenticacao = retorno;
            localStorage.setItem('ticketUsuario', retorno.ticket);
            this.router.navigateByUrl('/reports');
          }
        }),
        map(retorno => retorno),
        catchError(e => {
          console.log(e);
          return this.errorHandler(e);
        })
      );
  }

  funcaoAutenticarUsuario(login, senha): Observable<SaidaAutenticacao> {
    const url = `${this.utilService.funcaoObterURLAPI()}/conta/Autenticar`;
    return this.httpClient.post<SaidaAutenticacao>(url, { login, senha })
      .pipe(
        tap(retorno => {
          if (retorno.tipoRetorno === 2) {
            this._informacoesAutenticacao = retorno;
            localStorage.setItem('ticketUsuario', retorno.ticket);
            this.router.navigateByUrl('/reports');
          }
        }),
        map(retorno => retorno),
        catchError(e => {
          return this.errorHandler(e);
        })
      );
  }


  funcaoTentarRestaurarSessao = (emitirAlerta: boolean = true) => {
    var ticketUsuario = localStorage.getItem('ticketUsuario');
    if (ticketUsuario) {
      this.httpClient.post<SaidaAutenticacao>(`${this.utilService.funcaoObterURLAPI()}/conta/ObterDetalheSessaoPorTicket`, { ticketUsuario }).subscribe(
        (retorno) => {
          if (retorno?.ticket) {
            this._informacoesAutenticacao = retorno;
            this._informacoesAutenticacao.responseBacias = retorno.mensagemRetorno;
            if (emitirAlerta) {
              this._eventoLogin.emit(retorno);
            }

            if (this.router.url.startsWith('/conta/login') || this.router.url.startsWith('/mapasgeo') || this.router.url == '/') {
              this.router.navigateByUrl('');
            }
          }
          else {
            this.funcaoEfetuarLogout();
          }
        },
        (erro) => {
          this.funcaoEfetuarLogout();
        }
      );
    }
    else {
      this.funcaoEfetuarLogout();
    }
  }

  funcaoEfetuarLogout = (): void => {
    localStorage.removeItem('ticketUsuario');
    this._informacoesAutenticacao = null;
    if (!this.location.path().startsWith('/conta/nova-senha?ticket=') &&
      !this.location.path().startsWith('/conta/recuperar-senha') &&
      !this.location.path().startsWith('/conta')) {
      this.router.navigate(['/conta/login']);
    }
  }

  funcaoObterInformacoesAutenticacao = (): SaidaAutenticacao => {
    return this._informacoesAutenticacao;
  }

  errorHandler(e: any): Observable<any> {
    throw throwError(e);
  }
}
